import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { BrowserRouter, Switch } from 'react-router-dom'
import Loadable from 'react-loadable'
import TextLoading from './components/Common/Loading/TextLoading'
import './App.scss'
import UnauthenticatedRoute from './components/AuthenticationRoute/UnauthenticatedRoute'
import AuthenticatedRoute from './components/AuthenticationRoute/AuthenticatedRoute'
import injectSaga from './stores/injectSaga'
import rootSaga from './sagas'
import { URLs } from './constants/route'

const loading = () => <TextLoading />

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./Layouts/DefaultLayout'),
  loading
})

// Pages
const Login = Loadable({
  loader: () => import('./routes/LoginPage'),
  loading
})

const Register = Loadable({
  loader: () => import('./routes/RegisterPage'),
  loading
})

const Page404 = Loadable({
  loader: () => import('./routes/Page404'),
  loading
})

const Page403 = Loadable({
  loader: () => import('./routes/Page403'),
  loading
})

const Page500 = Loadable({
  loader: () => import('./routes/Page500'),
  loading
})

class App extends Component {
  render() {
    const { accessToken: token, accessPermissions, roles } = this.props.user
    return (
      <BrowserRouter>
        <Switch>
          <UnauthenticatedRoute
            exact
            path={URLs.LOGIN}
            name="Login Page"
            component={Login}
            accessToken={token}
            roles={roles}
          />
          <UnauthenticatedRoute
            exact
            path={URLs.REGISTER}
            name="Register Page"
            component={Register}
            accessToken={token}
            roles={roles}
          />
          <AuthenticatedRoute
            exact
            path={URLs[404]}
            name="Page 404"
            component={Page404}
            accessToken={token}
          />
          <AuthenticatedRoute
            exact
            path={URLs[403]}
            name="Page 403"
            component={Page403}
            accessToken={token}
          />
          <AuthenticatedRoute
            exact
            path={URLs[500]}
            name="Page 500"
            component={Page500}
            accessToken={token}
          />
          <AuthenticatedRoute
            path="/"
            name="Home"
            component={DefaultLayout}
            accessToken={token}
            accessPermissions={accessPermissions}
          />
        </Switch>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user
})

const withConnect = connect(mapStateToProps)
const withSaga = injectSaga({ key: 'rootSaga', saga: rootSaga })

export default compose(
  withSaga,
  withConnect
)(App)
